import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'
import AddressForm from '@/components/AddressForm.vue'


export default {
   $_veeValidate: {
      validator: 'new'
   },
      name: "YourAddress",
      components: {
         IconArrowBack,
         IconBase,
         IconCheck,
         IconForwardBack,
         BackButton,
         NextButton,
         AddressForm
      },
      mounted(){
         this.$parent.CheckWindowPathName();
         this.$validator.localize('en', this.dictionary);
         this.ValidateSessionData();
         this.$parent.CurrentProcess = "EducatorInsuranceProcess";
         //this.$parent.EducatorInsuranceProcess = Globals.CreateLocalData(this.$parent.Role);
      
      },
      data: () => ({
         hideRecipient: true,
         AllFieldsValid: false,
         data: {},
      }),
      computed: {
      },
      methods: {
         Next() { 
            let hey = this.$refs.checkForm.Confirm();
         },
         ReturnDataFromForm(_data){
            let _address = {};
            _address.name = this.$parent.EducatorInsuranceProcess.Educators[0].first_name + " " + this.$parent.EducatorInsuranceProcess.Educators[0].last_name; _address.street_number = _data.street_number;
            _address.street_address = _data.street_address;
            _address.postcode = _data.postcode;
            _address.suburb = _data.suburb;
            _address.state = _data.state;
            _address.isselected = true;

            if(this.$parent.EducatorInsuranceProcess.Addresses) {
               this.$parent.EducatorInsuranceProcess.Addresses[0] = _address;
            } else {
               this.$parent.EducatorInsuranceProcess.Addresses = [];
               this.$parent.EducatorInsuranceProcess.Addresses.push(_address);
            }
            
            if(this.state != 'NSW') {
               this.$parent.EducatorInsuranceProcess.small_business_disclaimer = null;
            }

            this.$parent.EducatorNextStep(2,"HelloUser");
    
            // this.$parent[this.$parent.CurrentProcess].Addresses.push(_data);
            // this.$parent.SessionUpdate(this.$parent.CurrentProcess);
         },
         NextButtonColor(_params){
            if(_params){
               this.AllFieldsValid = true;
            }else{
               this.AllFieldsValid = false;
            }
         },
         ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.Addresses != undefined) {
               const _address = this.$parent.EducatorInsuranceProcess.Addresses;
               if(_address.length > 0) {
                  this.data = {
                     "name": this.$parent.EducatorInsuranceProcess.Educators[0].first_name + " " + this.$parent.EducatorInsuranceProcess.Educators[0].last_name,
                     "street_number": _address[0].street_number,
                     "street_address": _address[0].street_address,
                     "suburb": _address[0].suburb,
                     "state": _address[0].state,
                     "postcode": _address[0].postcode,
                     "isselected": false,
                  }
               }
            }
         }
      },
}